import React from 'react';
import propTypes from 'prop-types';

export const NextFilledIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 561.803 561.802"
      xmlSpace="preserve"
      className={variant}
    >
      <g>
        <g>
          <polygon
            points="240.773,521.674 240.773,411.322 561.803,411.322 561.803,152.994 240.773,152.994 240.773,40.128 0,280.905 		
			"
          />
        </g>
      </g>
    </svg>
  );
};
NextFilledIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
NextFilledIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
